<template>
  <div class="exchange-container">
    <div class="wallet-info" v-if="connected">
      <div id="walletAddress" style="color: rebeccapurple;">{{ shortWalletAddress }}</div>
      <div id="walletBalanceTop" style="color:rebeccapurple;">金额: {{ walletBalanceTop.toFixed(6) }} USDT</div>
      <div id="sbsBalance" style="color: rebeccapurple;">CYC 余额: {{ sbsBalance.toFixed(6) }} CYC</div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Tabs -->
      <div class="tabs">
        <button :class="{ active: currentTab === 'swap' }" @click="currentTab = 'swap'">Swap</button>
        <button class="admin-button" @click="checkAdminPermissions">Admin</button>
      </div>

      <!-- Swap Form -->
      <div v-if="currentTab === 'swap'" class="swap-form">
        
        <!-- Sell Section -->
        <div class="input-section">
          <label>Sell</label>
          <input type="number" step="any" v-model="sellAmount" placeholder="0.0" />
          
          <select v-model="sellToken" class="token-select cyc-select">
            <option value="SBS">CYC</option>
          </select>

          <span>{{ sellAmount }} CYC = {{ calculatedBuyAmount }} USDT</span>
          <span style="color: red;">今日价格:1CYC = {{ exchangeRateHuman }} USDT</span>
        </div>

        <!-- Buy Section -->
        <div class="input-section">
          <label>Buy</label>
          <input type="number" step="any" v-model="calculatedBuyAmount" placeholder="0.0" readonly />
          
          <select v-model="buyToken" class="token-select usdt-select">
            <option value="USDT">USDT</option>
          </select>

          <span>{{ calculatedBuyAmount }} USDT</span>
        </div>

        <!-- Exchange Button -->
        <button class="exchange-button" @click="exchangeTokens">Exchange</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { tokenExchangeAddress, tokenExchangeAbi, usdtTokenAddress, usdtAbi, sbsTokenAddress, sbsAbi } from '@/js/contractssss.js';

export default {
  name: 'exchange',
  data() {
    return {
      currentTab: 'swap',
      sellAmount: 0,
      calculatedBuyAmount: 0,
      sellToken: 'SBS',
      buyToken: 'USDT',
      walletAddress: '未连接',
      shortWalletAddress: '未连接',
      walletBalanceTop: 0,
      sbsBalance: 0,
      connected: false,
      exchangeRate: 1000000,
      usdtContract: null,
      sbsContract: null,
      tokenExchangeContract: null,
      deployer: null,
      mounted: false
    };
  },
  watch: {
    sellAmount(newVal) {
      if (newVal > 0) {
        this.calculatedBuyAmount = (newVal * this.exchangeRate) / 1000000;
        this.calculatedBuyAmount = parseFloat(this.calculatedBuyAmount.toFixed(6));
      } else {
        this.calculatedBuyAmount = 0;
      }
    },
    exchangeRate(newVal) {
      if (this.sellAmount > 0) {
        this.calculatedBuyAmount = (this.sellAmount * newVal) / 1000000;
        this.calculatedBuyAmount = parseFloat(this.calculatedBuyAmount.toFixed(6));
      } else {
        this.calculatedBuyAmount = 0;
      }
    }
  },
  computed: {
    exchangeRateHuman() {
      return (this.exchangeRate / 1000000).toFixed(6);
    }
  },
  methods: {
    async connectWallet() {
      if (window.ethereum) {
        try {
          await window.ethereum.request({ method: 'eth_requestAccounts' });
          const provider = new ethers.providers.Web3Provider(window.ethereum);
          const signer = provider.getSigner();
          const address = await signer.getAddress();

          this.signer = signer;
          this.provider = provider;

          const tokenExchangeContract = new ethers.Contract(tokenExchangeAddress, tokenExchangeAbi, signer);
          this.tokenExchangeContract = tokenExchangeContract;

          const usdtContract = new ethers.Contract(usdtTokenAddress, usdtAbi, signer);
          this.usdtContract = usdtContract;

          const sbsContract = new ethers.Contract(sbsTokenAddress, sbsAbi, signer);
          this.sbsContract = sbsContract;

          const usdtBalance = await usdtContract.balanceOf(address);
          const usdtBalanceInUsdt = parseFloat(ethers.utils.formatUnits(usdtBalance, 6));

          const sbsBalance = await sbsContract.balanceOf(address);
          const sbsBalanceInSbs = parseFloat(ethers.utils.formatUnits(sbsBalance, 6));

          this.walletAddress = address;
          this.shortWalletAddress = `地址:${address.slice(0, 5)}...${address.slice(-4)}`;
          this.walletBalanceTop = usdtBalanceInUsdt;
          this.sbsBalance = sbsBalanceInSbs;
          this.connected = true;

          this.updateExchangeRate();
          this.fetchDeployer();
        } catch (error) {
          console.error(error);
          alert('连接钱包失败');
          this.connected = false;
        }
      } else {
        alert('请安装 MetaMask 插件');
        this.connected = false;
      }
    },
    async updateExchangeRate() {
      if (this.tokenExchangeContract) {
        try {
          const rate = await this.tokenExchangeContract.getCurrentExchangeRate();
          this.exchangeRate = parseFloat(rate.toString());
        } catch (error) {
          console.error(error);
          alert('获取兑换比例失败');
        }
      }
    },
    async exchangeTokens() {
      if (this.tokenExchangeContract && this.sellAmount > 0 && this.buyToken === 'USDT') {
        try {
          const sbsAmount = ethers.utils.parseUnits(this.sellAmount.toString(), 6);

          if (sbsAmount.gt(ethers.utils.parseUnits(this.sbsBalance.toString(), 6))) {
            alert('您的 SBS 余额不足');
            return;
          }

          const allowance = await this.sbsContract.allowance(this.walletAddress, tokenExchangeAddress);
          if (allowance.lt(sbsAmount)) {
            const approveTx = await this.sbsContract.approve(tokenExchangeAddress, sbsAmount);
            await approveTx.wait();
            console.log('SBS 批准完成');
          }

          const gasEstimate = await this.tokenExchangeContract.estimateGas.exchangeSBSForUSDT(sbsAmount);
          const gasLimit = gasEstimate.mul(120).div(100);

          const tx = await this.tokenExchangeContract.exchangeSBSForUSDT(sbsAmount, { gasLimit: gasLimit });
          await tx.wait();
          alert('兑换成功');
          this.updateBalances();
        } catch (error) {
          if (error.data && error.data.originalError) {
            console.error('合约错误详情:', error.data.originalError.message);
            alert('兑换失败。合约错误详情: ' + error.data.originalError.message);
          } else {
            console.error(error);
            alert('兑换失败。请重试。');
          }
        }
      } else {
        alert('请填入有效的兑换信息');
      }
    },
    async updateBalances() {
      if (this.tokenExchangeContract) {
        try {
          const usdtBalance = await this.usdtContract.balanceOf(this.walletAddress);
          const usdtBalanceInUsdt = parseFloat(ethers.utils.formatUnits(usdtBalance, 6));

          const sbsBalance = await this.sbsContract.balanceOf(this.walletAddress);
          const sbsBalanceInSbs = parseFloat(ethers.utils.formatUnits(sbsBalance, 6));

          this.walletBalanceTop = usdtBalanceInUsdt;
          this.sbsBalance = sbsBalanceInSbs;
          this.updateExchangeRate();
        } catch (error) {
          console.error(error);
          alert('获取余额失败');
        }
      }
    },
    async fetchDeployer() {
      if (this.tokenExchangeContract) {
        try {
          const deployer = await this.tokenExchangeContract.deployer();
          this.deployer = ethers.utils.getAddress(deployer);
        } catch (error) {
          console.error(error);
          alert('获取合约部署者信息失败');
        }
      }
    },
    checkAdminPermissions() {
      if (this.deployer && this.walletAddress && ethers.utils.getAddress(this.walletAddress) === this.deployer) {
        this.navigateToItem();
      } else {
        alert('您没有权限访问此页面。');
      }
    },
    navigateToItem() {
      this.$router.push({ path: '/admin' });
    }
  },
  mounted() {
    this.mounted = true;
    this.connectWallet();
  }
};
</script>

<style scoped>
.exchange-container {
 
  min-height: 100vh;
    width: 100%;
    /* background: url("@/assets/images/bgimg9.png") center center no-repeat fixed; */
    background-size: 100% 100%;
    background: rgb(135, 182, 216); 
    
  
 
}


.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.menu button {
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

.wallet-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  color: white;
}

.wallet-info div {
  color: white;
}

.tabs {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
}

.tabs button {
  background: #f0f0f0;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  color: black;
}

.tabs button.active {
  background: #e0e0e0;
}

.admin-button {
  background: #f0f0f0;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  color: black;
}

.swap-form {
  padding: 10px;
}

.input-section {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.input-section label {
  margin-bottom: 5px;
  color: white;
}

.input-section input,
.input-section select {
  padding: 5px;
  margin-bottom: 5px;
  background-color: white;
  color: black;
  border: none;
  border-radius: 4px;
}

.exchange-button {
  width: 100%;
  padding: 10px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

/* ====================== ✅ 正确图标样式 ====================== */
.token-select {
  padding-left: 32px !important;
  background-size: 25px 25px;
  background-position: 8px center;
  background-repeat: no-repeat;

  /* ========== 在这里调整 宽度 和 高度 ========== */
 
  height: 38px;       /* 选择框高度 */
  font-size: 16px;    /* 文字大小 */
  border-radius: 8px; /* 圆角（可选，更好看）*/
}

/* CYC 图标 */
.cyc-select {
  background-image: url("@/assets/images/cyc.png");
}

/* USDT 图标 */
.usdt-select {
  background-image: url("@/assets/images/USDT.png");
}
</style>